import { NoteIcon } from "./NoteIcon";

export default NoteIcon;
